import React, { useEffect, useState } from "react";
import { Carousel } from "react-bootstrap";
import PartnerSection from "../../../../components/page/home/org-structures/part";
import {
  public_company_list,
  public_institution_list,
  public_membership_list,
  public_mou_list,
  public_orgstruc_list,
  public_premises_list,
} from "../../public.api";

const partData = [
  {
    image: "/resources/logo/logo2.png",
    type: "1",
  },
  {
    image: "/251.png",
    type: "1",
  },
  {
    image: "/asna.png",
    type: "1",
  },
  {
    image: "/boson.png",
    type: "1",
  },
  {
    image: "/glorod.png",
    type: "1",
  },
  {
    image: "/sidco.png",
    type: "1",
  },
  {
    image: "/Volador.png",
    type: "1",
  },

  {
    image: "/DUK.jpeg",
    type: "3",
  },
  {
    image: "/ICTAK.png",
    type: "3",
  },
  {
    image: "/vssc.jpg",
    type: "3",
  },
  {
    image: "/members/ISPA.jpg",
    type: "2",
  },
  {
    image: "/members/SIA.jpg",
    type: "2",
  },
  {
    image: "/members/SIATI.png",
    type: "2",
  },
  {
    image: "/asap.png",
    type: "3",
  },
  {
    image: "/LPSC.png",
    type: "3",
  },
  {
    image: "/IISU.png",
    type: "3",
  },
  {
    image: "/STPI.png",
    type: "3",
  },
  {
    image: "/ku.png",
    type: "3",
  },
  {
    image: "/clg.jpg",
    type: "4",
  },
  {
    image: "/mcet.png",
    type: "4",
  },
  {
    image: "/sbce.jpg",
    type: "4",
  },
  {
    image: "/mbc.png",
    type: "4",
  },
  {
    image: "/wide.png",
    type: "4",
  },
  {
    image: "/companies/accurant.png",
    type: "0",
  },
  {
    image: "/companies/academic-new.jpg",
    type: "4",
  },
  { image: "/companies/aeroprecision.png", type: "0" },
  { image: "/c2.png", type: "2" },
  { image: "/ficci.png", type: "2" },
  { image: "/inaq.png", type: "2" },
  { image: "/companies/aerocaliph.png", type: "0" },
  { image: "/companies/alloysengineers.jpg", type: "0" },
  { image: "/companies/ananthtechnologies.png", type: "0" },
  { image: "/companies/ananthtechnologies.png", type: "3" },
  { image: "/companies/ariane.png", type: "0" },
  { image: "/companies/aryaelectronics.jpg", type: "0" },
  { image: "/companies/ARYA.jpg", type: "0" },
  { image: "/companies/bendraaerospace.jpg", type: "0" },
  { image: "/companies/brahmos.jpg", type: "0" },
  { image: "/companies/coreintimate.jpg ", type: "0" },
  { image: "/companies/cryoprecision.png", type: "0" },
  { image: "/companies/cryotrust.png", type: "0" },
  { image: "/companies/dcube.png", type: "0" },
  { image: "/companies/GSR.jpg", type: "0" },
  { image: "/companies/hex20.png", type: "0" },
  { image: "/companies/hirelfabs.jpeg", type: "0" },
  { image: "/companies/jocyt.png", type: "0" },
  { image: "/companies/kortas.png", type: "0" },
  { image: "/companies/mirox.jpg", type: "0" },
  { image: "/companies/misteo.png", type: "0" },
  { image: "/companies/mountengineering.png", type: "0" },
  { image: "/companies/MSTOOLROOM.jpg", type: "0" },
  { image: "/companies/nckmetals.jpg", type: "0" },
  { image: "/companies/okabasus.png", type: "0" },
  { image: "/companies/peoplessteel.jpg", type: "0" },
  { image: "/companies/riztech.png", type: "0" },
  { image: "/companies/rovonize.png", type: "0" },
  { image: "/companies/sifl.png", type: "0" },
  { image: "/companies/skylar.png", type: "0" },
  { image: "/companies/spacelabs.png", type: "0" },
  { image: "/companies/thinkpalm.png", type: "0" },
  { image: "/companies/thomasaero.jpg", type: "0" },
  { image: "/companies/toonz.jpg", type: "0" },
  { image: "/companies/travancoreaerospace.png", type: "0" },
  { image: "/companies/unicorp.png", type: "0" },
  { image: "/companies/UniqueSolution.png", type: "0" },
  { image: "/companies/Vaimanik.jpg", type: "0" },
  { image: "/companies/Vashishta.png", type: "0" },
  { image: "/companies/vikranthaerospace.png", type: "0" },
  { image: "/companies/vinvish.png", type: "0" },
  { image: "/adiShankara.jpg", type: "4" },
  { image: "/christ.png", type: "4" },
  { image: "/munnar.jpg", type: "4" },
  { image: "/sursum.png", type: "4" },
  { image: "/iisst.png", type: "3" },
  // {
  //   image: "/vssc.jpg",
  //   type: "4",
  // },
  // {
  //   image: "/vssc.jpg",
  //   type: "3",
  // },
];
// const partData = [
//   {
//     image: "/logo.png",
//     type: "0",
//   }, ]
export default function Partners(props) {
  const [data, setdata] = useState([]);
  const [activeItem, setActiveItem] = useState("0");
  const [url, setUrl] = useState("");
  const [isActive, setIsActive] = useState(false);
  const [key, setKey] = useState(1);
  const [mouList, setMouList] = useState([]);
  const [membershipList, setMembershipList] = useState([]);
  const [companyList, setCompanyList] = useState([]);
  const [premisesList, setPremisesList] = useState([]);
  const [institutionList, setInstitutionList] = useState([]);
  const servInstance = process.env.REACT_APP_BASE_URL;
  let result = servInstance.substring(0, servInstance?.length - 4);

  useEffect(() => {
    if (activeItem === "3") {
      handleEventList();
    }
    if (activeItem === "2") {
      handleMembershipList();
    }
    if (activeItem === "0") {
      handleCompanyList();
      console.log("step 1");
    }
    if (activeItem === "1") {
      handlePremisesList();
    }
    if (activeItem === "4") {
      handleInstitutionList();
    }
  }, [activeItem]);

  const handleEventList = async () => {
    const response = await public_mou_list();

    const logos =
      response?.map((item) => ({
        id: item.id,
        logo: item.logo,
        organization_name: item.organization_name,
      })) || [];
    setMouList(logos);
  };
  const handleMembershipList = async () => {
    const response = await public_membership_list();

    const logos =
      response?.map((item) => ({
        id: item.id,
        logo: item.logo,
        organization_name: item.organization_name,
      })) || [];
    setMembershipList(logos);
  };
  const handleCompanyList = async () => {
    const response = await public_company_list();
    console.log(response);
    const logos =
      response
        ?.filter((item) => item.logo && item.logo.trim() !== "")
        .map((item) => ({
          id: item.id,
          logo: `${result}${item.logo}`,
          organization_name: item.company_name,
        })) || [];

    setCompanyList(logos);
  };
  const handlePremisesList = async () => {
    const response = await public_premises_list();

    const logos =
      response
        ?.filter((item) => item.logo && item.logo.trim() !== "")
        .map((item) => ({
          id: item.id,
          logo: `${result}${item.logo}`,
          organization_name: item.company_name,
        })) || [];

    setPremisesList(logos);
  };
  const handleInstitutionList = async () => {
    const response = await public_institution_list();

    const logos =
      response
        ?.filter((item) => item.logo && item.logo.trim() !== "")
        .map((item) => ({
          id: item.id,
          logo: `${result}${item.logo}`,
          organization_name: item.company_name,
        })) || [];

    setInstitutionList(logos);
  };

  const filteredData =
    activeItem === "3"
      ? mouList
      : activeItem === "2"
        ? membershipList
        : activeItem === "0"
          ? companyList
          : activeItem === "1"
            ? premisesList
            : activeItem === "4"
              ? institutionList
              : partData;

  return (
    <div className="org-structure">
      <div className="org-strecture-title">
        {props.state.language === "ma" ? "ഞങ്ങളുടെ പങ്കാളികൾ" : "Our Partners"}
      </div>
      <div className="strec-cont-partners">
        <div className="tab-cont-cont-partners">
          <div className="tab-cont-partners">
            <div
              className={
                activeItem === "0"
                  ? "tab-switch-partners activeTab"
                  : "tab-switch-partners"
              }
              onClick={(e) => {
                setActiveItem("0");
                setKey(key + 1);
              }}
            >
              <div>
                {props.state.language === "ma"
                  ? "അനുബന്ധ കമ്പനികൾ"
                  : "Affiliated Companies"}
              </div>
            </div>
            <div
              className={
                activeItem === "1"
                  ? "tab-switch-partners activeTab"
                  : "tab-switch-partners"
              }
              onClick={(e) => {
                setActiveItem("1");
                setKey(key + 1);
              }}
            >
              <div>
                {props.state.language === "ma"
                  ? "കെസ്പേസിലെ കമ്പനികൾ"
                  : "Companies in KSPACE Premises"}
              </div>
            </div>
            <div
              className={
                activeItem === "3"
                  ? "tab-switch-partners activeTab"
                  : "tab-switch-partners"
              }
              onClick={() => {
                setActiveItem("3");
                setKey(key + 1);
              }}
            >
              <div>
                {props.state.language === "ma"
                  ? "ഞങ്ങളുടെ എംഒയുകൾ"
                  : "Our MOUs"}
              </div>
            </div>
            <div
              className={
                activeItem === "4"
                  ? "tab-switch-partners activeTab"
                  : "tab-switch-partners"
              }
              onClick={(e) => {
                setActiveItem("4");
                setKey(key + 1);
              }}
            >
              <div>
                {props.state.language === "ma"
                  ? "വിദ്യാഭ്യാസ സ്ഥാപനങ്ങൾ"
                  : "Academic Institutions"}
              </div>
            </div>
            <div
              className={
                activeItem === "2"
                  ? "tab-switch-partners activeTab"
                  : "tab-switch-partners"
              }
              onClick={(e) => {
                setActiveItem("2");
                setKey(key + 1);
              }}
            >
              <div>
                {props.state.language === "ma" ? "അംഗത്വം" : "Memberships"}
              </div>
            </div>
          </div>
        </div>

        <div className="strec-item-cont">
          <PartnerSection
            {...props}
            data={filteredData}
            mouList={mouList}
            membershipList={membershipList}
            companyList={companyList}
            premisesList={premisesList}
            institutionList={institutionList}
            fullwidth={true}
            active={activeItem}
            isActive={isActive}
            key={key}
          />
        </div>
      </div>
    </div>
  );
}
